import { cn } from '@/ui/utils/style'
import Link from 'next/link'
import type { ReactNode } from 'react'

export interface PillNavItem {
  label: string
  href: string
  icon?: ReactNode
  postfix?: ReactNode
  active?: boolean
}

interface PillNavProps {
  items: PillNavItem[]
  className?: string
}

export function PillNav({ items, className }: PillNavProps) {
  return (
    <div className={cn('inline-flex items-center gap-0 rounded-lg border border-white/10 p-1', className)}>
      {items.map((item) => (
        <Link
          key={item.href}
          href={item.href}
          className={cn(
            'flex h-7 items-center justify-center gap-1 rounded-md px-2 text-xs transition-colors sm:h-8 sm:gap-1.5 sm:px-3 sm:text-sm',
            item.active ? 'bg-white/10 text-white' : 'text-muted-foreground hover:text-white/70',
          )}
        >
          {item.icon}
          {item.label}
          {item.postfix}
        </Link>
      ))}
    </div>
  )
}
